import { Grid, Box, Container } from "@mui/material";
import { useFormik } from "formik";
import { setLocalStorageData } from "../../../../shared/utils/localStorage";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import { useContext, useState } from "react";
import { SnackBarAlertContext } from "../../../../contexts/SnackbarContext";
import { useNavigate } from "react-router-dom";
import { customizeValidationSchema } from "./customSchema";
import { NavLink } from "react-router-dom";
import LoginPageCard from "../../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../../shared/components/auth/menuContainer";

const Login = (props: any) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const textFields = [
    {
      id: "login-email",
      name: "email",
      placeholder: "Enter your email address",
      type: "text",
      required: true,
      label: "Email",
    },
    {
      id: "login-password",
      name: "password",
      placeholder: "Enter your password",
      type: "password",
      required: true,
      label: "Password",
    },
  ];
  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: customizeValidationSchema,
    onSubmit: async (loginData: any) => {
      setLoading(true);
      const response: any = await fetch(
        process.env.REACT_APP_API_URL + "/customer/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );
      // console.log("response------", response);
      if (response?.ok) {
        setLoading(false);
        setLocalStorageData("token", response.headers.get("token"));
        const responseData = await response.json();
        setLocalStorageData("user-name", responseData?.data?.email);
        setLocalStorageData("name", responseData?.data?.firstName);
        setLocalStorageData("userID", responseData?.data?.userID);
        setLocalStorageData("customerID", responseData?.data?.customerID);
        navigate("/dashboard");
      } else {
        setLoading(false);
        const error = await response.json();
        snackBarAlertContext.set({
          status: true,
          type: "error",
          message: error?.message,
        });
      }
    },
  });
  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid container sx={{ justifyContent: "center", alignItems: "end" }}>
            <Grid item md={4} xs={12}>
              <LoginPageCard>
                <MenuContainer />
                <form
                  onSubmit={loginForm.handleSubmit}
                  autoComplete="off"
                  className="loginForm"
                >
                  {textFields.map((field: any, index: number) => {
                    return (
                      <Grid sx={{ mt: 1 }} key={index}>
                        <InputTextfield
                          form={loginForm}
                          fieldProps={field}
                          key={index}
                        />
                      </Grid>
                    );
                  })}
                  <Grid sx={{ mt: 1 }} container spacing={1}>
                    <Grid item xs={12}>
                      <LoadingButton
                        loading={loading}
                        variant="contained"
                        type="submit"
                        fullWidth
                        size="small"
                        aria-label="Click here to login."
                      >
                        Login
                      </LoadingButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={8}
                      mt={4.5}
                      sx={{ textAlign: { xs: "center", sm: "right" } }}
                    >
                      <NavLink
                        to="/forgot-password"
                        className="forgot-password-link"
                        aria-label="Forgot your password? Click here to reset it."
                      >
                        Forgot password?
                      </NavLink>
                    </Grid>
                  </Grid>
                </form>
              </LoginPageCard>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default Login;
